export default __webpack_public_path__ + "static/media/about.6c164769.jpg";